import React from 'react'

import GraphLoader from 'app/domains/common/Loaders/GraphLoader'

const MyProgressLoader = ({ children }) => (
  <div className="loader">
    <div
      className="loader-row"
      style={{
        width: 200,
        height: 18,
        margin: '40px auto 0',
      }}
    />
    <div
      className="loader-row"
      style={{
        width: 170,
        height: 16,
        margin: '8px auto 0',
      }}
    />
    <GraphLoader />
  </div>
)

MyProgressLoader.displayName = 'MyProgressLoader'

export default MyProgressLoader
